import api from '@/services/api/config';

const path = 'v1/infra/fertigungsauftrag';

export default {
  get: (page, size, sort = null, desc = false, suche = null, status = null, zustand = null, teilegruppe = null, freigabestatus = null) => api.get(path, {
    params: {
      page, size, sort, desc, suche, status, zustand, teilegruppe, freigabestatus,
    },
  }),
  getAnzahl: (suche = null, status = null, zustand = null, teilegruppe = null, freigabestatus = null) => api.get(`${path}/anzahl`, {
    params: {
      suche, status, zustand, teilegruppe, freigabestatus,
    },
  }),
  getAufSperrlager: (page, size, sort = null, desc = false, suche = null, status = null, zustand = null, teilegruppe = null, freigabestatus = null) => api.get(`${path}/auf-sperrlager`, {
    params: {
      page, size, sort, desc, suche, status, zustand, teilegruppe, freigabestatus,
    },
  }),
  getAnzahlAufSperrlager: (suche = null, status = null, zustand = null, teilegruppe = null, freigabestatus = null) => api.get(`${path}/auf-sperrlager/anzahl`, {
    params: {
      suche, status, zustand, teilegruppe, freigabestatus,
    },
  }),
  getById: (id) => api.get(`${path}/${id}`),
  getOhnePck: (page, size, sort = null, desc = false, suche = null, zustand = null, teilegruppe = null) => api.get(`${path}/ohne_pck`, {
    params: {
      page, size, sort, desc, suche, zustand, teilegruppe,
    },
  }),
  getAnzahlOhnePck: (suche = null, zustand = null, teilegruppe = null) => api.get(`${path}/ohne_pck/anzahl`, {
    params: {
      suche, zustand, teilegruppe,
    },
  }),
  importOhnePck: () => api.post(`${path}/ohne_pck/import`),
  getPositionenOhnePck: (auftragsnummer) => api.get(`${path}/ohne_pck/positionen/${auftragsnummer}`),
};
